import { Button } from "@mui/material";
import React from "react";
import { palette } from "../../styles/palette";
import "./FixtureStyles.scss";

interface FixturePanelProps {
  setCurrentPanel: React.Dispatch<React.SetStateAction<string>>;
  currentPanel: string;
  isDesktop?: boolean;
}

const FixturePanel: React.FC<FixturePanelProps> = ({
  setCurrentPanel,
  currentPanel,
  isDesktop,
}) => {
  return (
    <div
      className={isDesktop ? undefined : "groupPanelScroll"}
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: isDesktop ? "center" : "flex-start",
        // Stable band height so the panel doesn't reflow as content/fonts settle
        // right after navigation; buttons (40px) sit centered within it.
        minHeight: isDesktop ? "70px" : "56px",
        gap: isDesktop ? "40px" : "8px",
        marginTop: isDesktop ? "12px" : undefined,
        overflowX: isDesktop ? undefined : "auto",
        flexWrap: "nowrap",
        padding: isDesktop ? undefined : "0 10px",
        boxSizing: "border-box",
        // Mobile: keep the tabs reachable while a tall panel (e.g. Stadiums) scrolls.
        // flexShrink 0 is required because overflowX:auto sets the flex item's
        // automatic min-size to 0, which otherwise lets tall content squash the
        // panel to a sliver inside the bounded (flex:1) scroll root.
        flexShrink: 0,
        position: isDesktop ? undefined : "sticky",
        top: isDesktop ? undefined : 0,
        zIndex: isDesktop ? undefined : 10,
        background: isDesktop ? undefined : palette.bgApp,
        // Subtle divider so the scrolling tiles read as passing underneath the bar.
        borderBottom: isDesktop ? undefined : `1px solid ${palette.border}`,
      }}
    >
      <PanelButton
        label="Upcoming"
        onClick={setCurrentPanel}
        isActive={currentPanel === "Upcoming"}
        isDesktop={isDesktop}
      />
      <PanelButton
        label="Group Stage"
        onClick={setCurrentPanel}
        isActive={currentPanel === "Group Stage"}
        isDesktop={isDesktop}
      />
      <PanelButton
        label="Knockout"
        onClick={setCurrentPanel}
        isActive={currentPanel === "Knockout"}
        isDesktop={isDesktop}
      />
      {!isDesktop && (
        <PanelButton
          label="Info"
          onClick={setCurrentPanel}
          isActive={currentPanel === "Info"}
          isDesktop={isDesktop}
        />
      )}
    </div>
  );
};

export default FixturePanel;

interface PanelButtonProps {
  label: string;
  onClick: React.Dispatch<React.SetStateAction<string>>;
  isActive: boolean;
  isDesktop?: boolean;
}
export const PanelButton: React.FC<PanelButtonProps> = ({
  label,
  onClick,
  isActive,
  isDesktop,
}) => {
  return (
    <Button
      style={
        isActive
          ? {
              background: palette.teal,
              color: palette.tealText,
              textTransform: "none",
              fontWeight: "600",
              padding: "0 20px",
              height: "40px",
              flexShrink: 0,
              width: isDesktop ? "250px" : undefined,
            }
          : {
              background: palette.bgSurface,
              color: palette.textPrimary,
              textTransform: "none",
              fontWeight: "600",
              padding: "7.5px 20px",
              height: "40px",
              flexShrink: 0,
              width: isDesktop ? "250px" : undefined,
            }
      }
      onClick={() => onClick(label)}
    >
      {label}
    </Button>
  );
};
